import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

function CountdownScreen({ score, total }) {
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const countdownTimer = window.setInterval(() => {
      setCountdown((value) => Math.max(value - 1, 0));
    }, 1000);

    const redirectTimer = window.setTimeout(() => {
      const result = { score, total };

      try {
        window.sessionStorage.setItem(
          'niegewoonQuizResult',
          JSON.stringify(result)
        );
      } catch {
        // De URL bevat de score als betrouwbare fallback.
      }

      window.location.replace(
        `https://niegewoon.be/quizuitslag?score=${score}&total=${total}`
      );
    }, 3000);

    return () => {
      window.clearInterval(countdownTimer);
      window.clearTimeout(redirectTimer);
    };
  }, [score, total]);

  return (
    <div className="countdown-screen" role="status" aria-live="polite">
      <motion.div
        className="countdown-bubble"
        key={countdown}
        initial={{ scale: 0.75, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.35 }}
      >
        {countdown}
      </motion.div>
      <span className="section-kicker">Da’s niegewoon</span>
      <h1>Je resultaat komt eraan.</h1>
      <p>
        We zetten je score klaar. Nog even geduld, daarna ontdek je wat jouw
        beeld van gezinszorg vertelt.
      </p>
    </div>
  );
}

export default CountdownScreen;